import { CheckCircle, XCircle } from 'lucide-react';

export const PASSWORD_REQUIREMENTS = [
  { label: 'At least 8 characters', test: (p) => p.length >= 8 },
  { label: 'One uppercase letter', test: (p) => /[A-Z]/.test(p) },
  { label: 'One lowercase letter', test: (p) => /[a-z]/.test(p) },
  { label: 'One number', test: (p) => /[0-9]/.test(p) },
  { label: 'One special character (!@#$%...)', test: (p) => /[!@#$%^&*()\-_=+[\]{}|;:'",.<>?/`~\\]/.test(p) },
];

export function validatePasswordPolicy(password) {
  return PASSWORD_REQUIREMENTS.every(r => r.test(password || ''));
}

export function PasswordStrengthChecklist({ password }) {
  if (!password) return null;
  return (
    <ul className="space-y-1 mt-2">
      {PASSWORD_REQUIREMENTS.map((req) => {
        const ok = req.test(password);
        return (
          <li key={req.label} className={`flex items-center gap-1.5 text-xs ${ok ? 'text-green-600' : 'text-red-500'}`}>
            {ok ? <CheckCircle className="h-3.5 w-3.5 shrink-0" /> : <XCircle className="h-3.5 w-3.5 shrink-0" />}
            {req.label}
          </li>
        );
      })}
    </ul>
  );
}
